// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"ec08bb69","300":"fbe0f862","318":"d44714ce","873":"bf9c60f6"}[chunkId] + ".chunk.css";
};